var envirment_id = "pr";

// 商品画像パスリスト
var goodsImgList = {
    "dev" : "http://10.235.27.7:8802/ols/wearable/component/goods/images/model/",
    "dev_mock" : "http://10.235.27.7:8802/ols/wearable/component/goods/images/model/",
    "browserstack": "https://online-shop.mb.softbank.jp/ols/wearable/component/goods/images/model/",
    "it1" : "http://10.235.27.7:8802/ols/wearable/component/goods/images/model/",
    "it2" : "http://10.235.27.7:8802/ols/wearable/component/goods/images/model/",
    "st" : "https://online-shop.mb.softbank.jp/ols/wearable/component/goods/images/model/",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/wearable/component/goods/images/model/",
    "pr" : "https://online-shop.mb.softbank.jp/ols/wearable/component/goods/images/model/",
    "default" : "http://10.235.27.7:8802/ols/wearable/component/goods/images/model/"
};

//カード会社画像パスリスト
var cardCompanyImgList = {
    "dev" : "http://10.235.27.7:8802/ols/component/common/images/",
    "dev_mock" : "http://10.235.27.7:8802/ols/component/common/images/",
    "browserstack": "https://online-shop.mb.softbank.jp/ols/component/common/images/",
    "it1" : "http://10.235.27.7:8802/ols/component/common/images/",
    "it2" : "http://10.235.27.7:8802/ols/component/common/images/",
    "st" : "https://online-shop.mb.softbank.jp/ols/component/common/images/",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/common/images/",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/common/images/",
    "default" : "http://10.235.27.7:8802/ols/component/common/images/"
};

//その他の確認書類URLリスト
var kakuninList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/kakunin.html",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/kakunin.html",
    "browserstack": "https://st.online-shop.mb.softbank.jp/ols/component/rect/kakunin.html",
    "it1" : "http://10.235.27.7:8802/ols/component/rect/kakunin.html",
    "it2" : "http://10.235.27.7:8802/ols/component/rect/kakunin.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/kakunin.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/kakunin.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/rect/kakunin.html",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/kakunin.html"
};

// olsInitStringリスト
var olsInitStringList = {
    "dev" : "",
    "dev_mock" : 'Utils.loadScript("../mock/js/jquery.mockjax.js", function () {'
                + "    console.log('script loaded');"
                + '    $.mockjaxSettings.matchInRegistrationOrder = false;'
                + '    Utils.loadScript("../mock/all.js", function () {'
                + "        console.log('mock script loaded.');"
                + '        OLS.init();'
                + '    });'
                + '});',
    "browserstack" : "",
    "it1" : "",
    "it2" : "OLS.init()",
    "st" : 'Utils.loadScript("../mock/js/jquery.mockjax.js", function () {'
                + "    console.log('script loaded');"
                + '    $.mockjaxSettings.matchInRegistrationOrder = false;'
                + '    Utils.loadScript("../mock/all.js", function () {'
                + "        console.log('mock script loaded.');"
                + '        OLS.init();'
                + '    });'
                + '});',
    "jedi_ols_st" : "OLS.init()",
    "pr" : "OLS.init()",
    "default" : "OLS.init()"
};

// 認証URLリスト
var approveurlList = {
    "dev" : "loginMock.html",
    "dev_mock" : "loginMock.html",
    "browserstack" : "loginMock.html",
    "it1" : "loginMock.html",
    "it2" : "/aw/login",
    "st" : "loginMock.html",
    "jedi_ols_st" : "/aw/login/",
    "pr" : "/aw/login/",
    "default" : "/aw/login"
};

// 二段認証URLリスト
var secondApproveurlList = {
    "dev" : "secondLoginMock.html",
    "dev_mock" : "secondLoginMock.html",
    "browserstack" : "secondLoginMock.html",
    "it1" : "/aw/login/?type=secondary",
    "it2" : "/aw/login/?type=secondary",
    "st" : "secondLoginMock.html",
    "jedi_ols_st" : "/aw/login/?type=secondary",
    "pr" : "/aw/login/?type=secondary",
    "default" : "/aw/login/?type=secondary"
};

// GA実行stringリスト
var gaList = {
    "dev": "",
    "dev_mock" : "",
    "browserstack" : "",
    "it1": "",
    "it2": "",
    "st": "",
    "jedi_ols_st" : "",
    "pr": "CreateGA()",
    "default": ""
}

// WTRリスト
var wtrList = {
    "dev": "",
    "dev_mock" : "",
    "browserstack" : "",
    "it1": "",
    "it2": "http://10.157.82.62:8101/sba/js/sb_analytics_client.js",
    "st": "",
    "jedi_ols_st" : "",
    "pr": "https://wtr.mb.softbank.jp/sba/js/sb_analytics_client.js",
    "default": ""
}

// ケースサイズリスト
var caseSizeList = {
    "dev" : "casesize.html",
    "dev_mock" : "casesize.html",
    "browserstack" : "casesize.html",
    "it1" : "casesize.html",
    "it2" : "casesize.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/wearable/component/inc/casesize.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/wearable/component/inc/casesize.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/wearable/component/inc/casesize.html",
    "default" : "casesize.html"
};

// 新トクするサポート？リスト
var tokusaPlusPopBtnList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/tokusuru_support_plus_aw.html",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/tokusuru_support_plus_aw.html",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/tokusuru_support_plus_aw.html",
    "it1" : "http://10.235.27.7:8802/ols/component/tip/tokusuru_support_plus_aw.html",
    "it2" : "http://10.235.27.7:8802/ols/component/tip/tokusuru_support_plus_aw.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/tokusuru_support_plus_aw.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/tokusuru_support_plus_aw.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/tip/tokusuru_support_plus_aw.html",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/tokusuru_support_plus_aw.html"
};

// 新トクするサポート？リスト Google Pixel Watch
var tokusaPlusPopBtnListWd = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/tokusuru_support_plus_wd.html",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/tokusuru_support_plus_wd.html",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/tokusuru_support_plus_wd.html",
    "it1" : "http://10.235.27.7:8802/ols/component/tip/tokusuru_support_plus_wd.html",
    "it2" : "http://10.235.27.7:8802/ols/component/tip/tokusuru_support_plus_wd.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/tokusuru_support_plus_wd.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/tokusuru_support_plus_wd.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/tip/tokusuru_support_plus_wd.html",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/tokusuru_support_plus_wd.html"
};

// あんしん保証パック？リスト
var anshinPackBtnList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/",
    "it1" : "http://10.235.27.7:8802/",
    "it2" : "http://10.235.27.7:8802/",
    "st" : "https://st.online-shop.mb.softbank.jp/",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/",
    "pr" : "https://online-shop.mb.softbank.jp/",
    "default" : "https://st.online-shop.mb.softbank.jp/"
};

// 重要オプション訴求ダイアログ
var safePackDialogPCList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-aw-pc.png",
    "dev_mock" : "http://10.235.27.7:8802/ols/component/inc/plan/images/anshin-aw-pc.png",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-aw-pc.png",
    "it1" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-aw-pc.png",
    "it2" : "http://10.235.27.7:8802/ols/component/inc/plan/images/anshin-aw-pc.png",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-aw-pc.png",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-aw-pc.png",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-aw-pc.png",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-aw-pc.png"
};
var safePackDialogSPList = {
	    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-aw-sp.png",
	    "dev_mock" : "http://10.235.27.7:8802/ols/component/inc/plan/images/anshin-aw-sp.png",
	    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-aw-sp.png",
	    "it1" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-aw-sp.png",
	    "it2" : "http://10.235.27.7:8802/ols/component/inc/plan/images/anshin-aw-sp.png",
	    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-aw-sp.png",
	    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-aw-sp.png",
	    "pr" : "https://online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-aw-sp.png",
	    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-aw-sp.png"
	};

// 重要オプション訴求ダイアログ Google Pixel Watch
var safePackDialogPCListWd = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-wd-pc.png",
    "dev_mock" : "http://10.235.27.7:8802/ols/component/inc/plan/images/anshin-wd-pc.png",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-wd-pc.png",
    "it1" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-wd-pc.png",
    "it2" : "http://10.235.27.7:8802/ols/component/inc/plan/images/anshin-wd-pc.png",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-wd-pc.png",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-wd-pc.png",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-wd-pc.png",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-wd-pc.png"
};
var safePackDialogSPListWd = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-wd-sp.png",
    "dev_mock" : "http://10.235.27.7:8802/ols/component/inc/plan/images/anshin-wd-sp.png",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-wd-sp.png",
    "it1" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-wd-sp.png",
    "it2" : "http://10.235.27.7:8802/ols/component/inc/plan/images/anshin-wd-sp.png",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-wd-sp.png",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-wd-sp.png",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-wd-sp.png",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-wd-sp.png"
};

//新トクするサポート良品の判断基準を確認する
var newTokusaUseCriteriaUrlList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_07.html",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_07.html",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_07.html",
    "it1" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_07.html",
    "it2" : "http://10.235.27.7:8802/ols/component/rect/mobile_satei_07.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_07.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_07.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_07.html",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_07.html"
};

//機種契約番号がわからない方はこちら
var useModelDetailGoodsMsnUrlList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/check_device_msn.html",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/check_device_msn.html",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/check_device_msn.html",
    "it1" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/check_device_msn.html",
    "it2" : "http://10.235.27.7:8802/ols/component/rect/check_device_msn.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/check_device_msn.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/check_device_msn.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/rect/check_device_msn.html",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/check_device_msn.html"
};

// 新トクするサポートダイアログリスト
var tokusaPlusDialogList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/campaign/tokusuru_support_plus_aw.html",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/campaign/tokusuru_support_plus_aw.html",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/campaign/tokusuru_support_plus_aw.html",
    "it1" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/campaign/tokusuru_support_plus_aw.html",
    "it2" : "http://10.235.27.7:8802/ols/component/inc/campaign/tokusuru_support_plus_aw.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/campaign/tokusuru_support_plus_aw.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/campaign/tokusuru_support_plus_aw.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/inc/campaign/tokusuru_support_plus_aw.html",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/campaign/tokusuru_support_plus_aw.html"
};

// 新トクするサポートダイアログリストGoogle Pixel Watch
var tokusaPlusDialogListWd = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/campaign/tokusuru_support_plus_wd.html",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/campaign/tokusuru_support_plus_wd.html",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/campaign/tokusuru_support_plus_wd.html",
    "it1" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/campaign/tokusuru_support_plus_wd.html",
    "it2" : "http://10.235.27.7:8802/ols/component/inc/campaign/tokusuru_support_plus_wd.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/campaign/tokusuru_support_plus_wd.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/campaign/tokusuru_support_plus_wd.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/inc/campaign/tokusuru_support_plus_wd.html",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/campaign/tokusuru_support_plus_wd.html"
};

//下取りプログラム良品の判断基準を確認する
var mobileSatei06CriteriaUrlList = {
"dev" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_06.html",
"dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_06.html",
"browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_06.html",
"it1" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_06.html",
"it2" : "http://10.235.27.7:8802/ols/component/rect/mobile_satei_06.html",
"st" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_06.html",
"jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_06.html",
"pr" : "https://online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_06.html",
"default" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_06.html"
};

//下取りプログラム「詳細をみる」リンク先
var tradeInKisyuUrlList = {
"dev" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/trade_in_kisyu.html",
"dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/trade_in_kisyu.html",
"browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/trade_in_kisyu.html",
"it1" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/trade_in_kisyu.html",
"it2" : "http://10.235.27.7:8802/ols/component/rect/trade_in_kisyu.html",
"st" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/trade_in_kisyu.html",
"jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/trade_in_kisyu.html",
"pr" : "https://online-shop.mb.softbank.jp/ols/component/rect/trade_in_kisyu.html",
"default" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/trade_in_kisyu.html"
};

//下取りプログラム特典金額を確認する
var tradeInTokutenUrlList = {
  "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/trade_in_tokuten.html",
  "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/trade_in_tokuten.html",
  "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/trade_in_tokuten.html",
  "it1" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/trade_in_tokuten.html",
  "it2" : "http://10.235.27.7:8802/ols/component/rect/trade_in_tokuten.html",
  "st" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/trade_in_tokuten.html",
  "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/trade_in_tokuten.html",
  "pr" : "https://online-shop.mb.softbank.jp/ols/component/rect/trade_in_tokuten.html",
  "default" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/trade_in_tokuten.html"
};

// セキュリティコード？リスト
var securityCodeList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/security_code.html",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/security_code.html",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/security_code.html",
    "it1" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/security_code.html",
    "it2" : "http://10.235.27.7:8802/ols/component/tip/security_code.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/security_code.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/security_code.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/tip/security_code.html",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/security_code.html"
};

// 予約遷移
var olsApplyList = {
    "dev" : "https://st.online-reserve.mb.softbank.jp/ors/?",
    "dev_mock" : "https://st.online-reserve.mb.softbank.jp/ors/?",
    "browserstack" : "https://st.online-reserve.mb.softbank.jp/ors/?",
    "it1" : "https://st.online-reserve.mb.softbank.jp/ors/?",
    "it2" : "https://st.online-reserve.mb.softbank.jp/ors/?",
    "st" : "https://st.online-reserve.mb.softbank.jp/ors/?",
    "jedi_ols_st" : "https://st.online-reserve.mb.softbank.jp/ors/?",
    "pr" : "https://online-reserve.mb.softbank.jp/ors/?",
    "default" : "https://st.online-reserve.mb.softbank.jp/ors/?"
}

// 郵便番号を調べるリスト
var postalCodeList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/postal_code.html",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/postal_code.html",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/postal_code.html",
    "it1" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/postal_code.html",
    "it2" : "http://10.235.27.7:8802/ols/component/rect/postal_code.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/postal_code.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/postal_code.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/rect/postal_code.html",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/postal_code.html"
};

// お知らせの詳細を確認する
var mailaddressList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/wearable/component/rect/mailaddress.html",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/wearable/component/rect/mailaddress.html",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/wearable/component/rect/mailaddress.html",
    "it1" : "https://st.online-shop.mb.softbank.jp/ols/wearable/component/rect/mailaddress.html",
    "it2" : "http://10.235.27.7:8802/ols/wearable/component/rect/mailaddress.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/wearable/component/rect/mailaddress.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/wearable/component/rect/mailaddress.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/wearable/component/rect/mailaddress.html",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/wearable/component/rect/mailaddress.html"
}

// 割賦契約の同意事項リスト
var installmentAgreeList = {
    "dev" : "agreement/kiyaku_contents/installment_agree.html",
    "dev_mock" : "agreement/kiyaku_contents/installment_agree.html",
    "browserstack" : "agreement/kiyaku_contents/installment_agree.html",
    "it1" : "agreement/kiyaku_contents/installment_agree.html",
    "it2" : "http://10.235.27.7:8802/ols/component/inc/installment_agree.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/installment_agree.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/installment_agree.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/inc/installment_agree.html",
    "default" : "agreement/kiyaku_contents/installment_agree.html"
}

// 個人情報の取扱・購入時の注意事項リスト
var personalInformationAttentionList = {
    "dev" : "agreement/kiyaku_contents/personal_information_attention.html",
    "dev_mock" : "agreement/kiyaku_contents/personal_information_attention.html",
    "browserstack" : "agreement/kiyaku_contents/personal_information_attention.html",
    "it1" : "agreement/kiyaku_contents/personal_information_attention.html",
    "it2" : "http://10.235.27.7:8802/ols/wearable/component/inc/personal_information_attention.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/wearable/component/inc/personal_information_attention.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/wearable/component/inc/personal_information_attention.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/wearable/component/inc/personal_information_attention.html",
    "default" : "agreement/kiyaku_contents/personal_information_attention.html"
}

// 移動機物品販売の注意事項リスト
var machineInformationAttentionList = {
    "dev" : "agreement/kiyaku_contents/product_sales_agree.html",
    "dev_mock" : "agreement/kiyaku_contents/product_sales_agree.html",
    "browserstack" : "agreement/kiyaku_contents/product_sales_agree.html",
    "it1" : "agreement/kiyaku_contents/product_sales_agree.html",
    "it2" : "http://10.235.27.7:8802/ols/component/inc/product_sales_agree.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/product_sales_agree.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/product_sales_agree.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/inc/product_sales_agree.html",
    "default" : "agreement/kiyaku_contents/installment_agree.html"
}

// 新トクするサポート特典利用に関する注意事項リスト
var newTokusuruSupportInfoAttentionList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/new_tokusuru_support_tokuten.html",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/new_tokusuru_support_tokuten.html",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/new_tokusuru_support_tokuten.html",
    "it1" : "http://10.235.27.7:8802/ols/component/inc/new_tokusuru_support_tokuten.html",
    "it2" : "http://10.235.27.7:8802/ols/component/inc/new_tokusuru_support_tokuten.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/new_tokusuru_support_tokuten.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/new_tokusuru_support_tokuten.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/inc/new_tokusuru_support_tokuten.html",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/new_tokusuru_support_tokuten.html"
}

//下取りに関する同意事項
var campaignInfoAttentionList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/trade_in.html",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/trade_in.html",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/trade_in.html",
    "it1" : "http://10.235.27.7:8802/ols/component/inc/trade_in.html",
    "it2" : "http://10.235.27.7:8802/ols/component/inc/trade_in.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/trade_in.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/trade_in.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/inc/trade_in.html",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/trade_in.html"
}

// 新トクするサポートに関する注意事項リスト
var newTokusuruSupportAttentionList = {
    "dev" : "agreement/kiyaku_contents/new_tokusuru_support.html",
    "dev_mock" : "agreement/kiyaku_contents/new_tokusuru_support.html",
    "browserstack" : "agreement/kiyaku_contents/new_tokusuru_support.html",
    "it1" : "agreement/kiyaku_contents/new_tokusuru_support.html",
    "it2" : "http://10.235.27.7:8802/ols/component/inc/new_tokusuru_support.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/new_tokusuru_support.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/new_tokusuru_support.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/inc/new_tokusuru_support.html",
    "default" : "agreement/kiyaku_contents/new_tokusuru_support.html"
}

// 商品の返品・交換に関する注意事項リスト
var returnList = {
    "dev" : "agreement/kiyaku_contents/return.html",
    "dev_mock" : "agreement/kiyaku_contents/return.html",
    "browserstack" : "agreement/kiyaku_contents/return.html",
    "it1" : "agreement/kiyaku_contents/return.html",
    "it2" : "agreement/kiyaku_contents/return.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/return.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/return.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/inc/return.html",
    "default" : "agreement/kiyaku_contents/return.html"
}

//3-Dセキュア対応注意事項リスト
var threeDAgreeAttentionList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/terms_3dsecure.html",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/terms_3dsecure.html",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/terms_3dsecure.html",
    "it1" : "http://10.235.27.7:8802/ols/component/inc/terms_3dsecure.html",
    "it2" : "http://10.235.27.7:8802/ols/component/inc/terms_3dsecure.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/terms_3dsecure.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/terms_3dsecure.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/inc/terms_3dsecure.html",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/terms_3dsecure.html"
}

// ポイントについて詳細説明リスト
var pointList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/point.html",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/point.html",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/point.html",
    "it1" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/point.html",
    "it2" : "http://10.235.27.7:8802/ols/component/rect/point.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/point.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/point.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/rect/point.html",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/point.html"
}

// 申し込み情報確認用リスト
var confirmInformationList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/wearable/component/rect/confirm_information_aw.html?searchOrderNo=",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/wearable/component/rect/confirm_information_aw.html?searchOrderNo=",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/wearable/component/rect/confirm_information_aw.html?searchOrderNo=",
    "it1" : "https://st.online-shop.mb.softbank.jp/ols/wearable/component/rect/confirm_information_aw.html?searchOrderNo=",
    "it2" : "http://10.235.27.7:8802/ols/wearable/component/rect/confirm_information_aw.html?searchOrderNo=",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/wearable/component/rect/confirm_information_aw.html?searchOrderNo=",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/wearable/component/rect/confirm_information_aw.html?searchOrderNo=",
    "pr" : "https://online-shop.mb.softbank.jp/ols/wearable/component/rect/confirm_information_aw.html?searchOrderNo=",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/wearable/component/rect/confirm_information_aw.html?searchOrderNo="
}

// 申し込み情報確認用リスト Google Pixel Watch
var confirmInformationListWd = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/wearable/component/rect/confirm_information_wd.html?searchOrderNo=",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/wearable/component/rect/confirm_information_wd.html?searchOrderNo=",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/wearable/component/rect/confirm_information_wd.html?searchOrderNo=",
    "it1" : "https://st.online-shop.mb.softbank.jp/ols/wearable/component/rect/confirm_information_wd.html?searchOrderNo=",
    "it2" : "http://10.235.27.7:8802/ols/wearable/component/rect/confirm_information_wd.html?searchOrderNo=",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/wearable/component/rect/confirm_information_wd.html?searchOrderNo=",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/wearable/component/rect/confirm_information_wd.html?searchOrderNo=",
    "pr" : "https://online-shop.mb.softbank.jp/ols/wearable/component/rect/confirm_information_wd.html?searchOrderNo=",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/wearable/component/rect/confirm_information_wd.html?searchOrderNo="
}

// 機種情報Jsonリスト
var modelJsonList = {
    "dev" : "/aw/user_json/appleWatchInfo.json",
    "dev_mock" : "/aw/user_json/appleWatchInfo.json",
    "browserstack" : "/aw/user_json/appleWatchInfo.json",
    "it1" : "/aw/user_json/appleWatchInfo.json",
    "it2" : "/aw/user_json/appleWatchInfo.json",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/mobile/products/user_json/appleWatchInfo.json",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/mobile/products/user_json/appleWatchInfo.json",
    "pr" : "https://online-shop.mb.softbank.jp/ols/mobile/products/user_json/appleWatchInfo.json",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/mobile/products/user_json/appleWatchInfo.json"
}

// 機種情報Jsonリスト Google Pixel Watch
var gpwModelJsonList = {
    "dev" : "/aw/user_json/pixelWatchInfo.json",
    "dev_mock" : "/aw/user_json/pixelWatchInfo.json",
    "browserstack" : "/aw/user_json/pixelWatchInfo.json",
    "it1" : "/aw/user_json/pixelWatchInfo.json",
    "it2" : "/aw/user_json/pixelWatchInfo.json",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/mobile/products/user_json/pixelWatchInfo.json",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/mobile/products/user_json/pixelWatchInfo.json",
    "pr" : "https://online-shop.mb.softbank.jp/ols/mobile/products/user_json/pixelWatchInfo.json",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/mobile/products/user_json/pixelWatchInfo.json"
}

// 本人確認について更に詳しく見るリスト
var selfConfirmDetailList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/self_confirm_detail.html",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/self_confirm_detail.html",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/self_confirm_detail.html",
    "it1" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/self_confirm_detail.html",
    "it2" : "http://10.235.27.7:8802/ols/component/rect/self_confirm_detail.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/self_confirm_detail.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/self_confirm_detail.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/rect/self_confirm_detail.html",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/self_confirm_detail.html"
}

// クレジット番号等を設定し、トークンPANを取得(TOR)
var TOR_URL = {
    "dev" : "https://st.torapj.mb.softbank.jp/tor/api/authori",
    "dev_mock" : "https://st.torapj.mb.softbank.jp/tor/api/authori",
    "browserstack" : "https://st.torapj.mb.softbank.jp/tor/api/authori",
    "it1" : "https://st.torapj.mb.softbank.jp/tor/api/authori",
    "it2" : "https://st.torapj.mb.softbank.jp/tor/api/authori",
    "st" : "https://st.torapj.mb.softbank.jp/tor/api/authori",
    "jedi_ols_st" : "https://st.torapj.mb.softbank.jp/tor/api/authori",
    "pr" : "https://torapj.mb.softbank.jp/tor/api/authori",
    "default" : "https://st.torapj.mb.softbank.jp/tor/api/authori"
}
var TOR_URL_IP = {
    "dev" : "http://10.157.83.218:18080/tor/api/authori",
    "dev_mock" : "http://10.157.83.218:18080/tor/api/authori",
    "browserstack" : "http://10.157.83.218:18080/tor/api/authori",
    "it1" : "http://10.157.83.218:18080/tor/api/authori",
    "it2" : "http://10.157.83.218:18080/tor/api/authori",
    "st" : "http://10.157.83.218:18080/tor/api/authori",
    "jedi_ols_st" : "http://10.157.83.218:18080/tor/api/authori",
    "pr" : "https://torapj.mb.softbank.jp/tor/api/authori",
    "default" : "http://10.157.83.218:18080/tor/api/authori"
}
// SBPSトークンシステムURL
var SBPS_TOKEN_URL = {
    "dev" : "https://stbtoken.sps-system.com/sbpstoken/com_sbps_system_token.js",
    "dev_mock" : "https://stbtoken.sps-system.com/sbpstoken/com_sbps_system_token.js",
    "browserstack" : "https://stbtoken.sps-system.com/sbpstoken/com_sbps_system_token.js",
    "it1" : "https://stbtoken.sps-system.com/sbpstoken/com_sbps_system_token.js",
    "it2" : "https://stbtoken.sps-system.com/sbpstoken/com_sbps_system_token.js",
    "st" : "https://stbtoken.sps-system.com/sbpstoken/com_sbps_system_token.js",
    "jedi_ols_st" : "https://stbtoken.sps-system.com/sbpstoken/com_sbps_system_token.js",
    "pr" : "https://token.sps-system.com/sbpstoken/com_sbps_system_token.js",
    "default" : "https://stbtoken.sps-system.com/sbpstoken/com_sbps_system_token.js"
}

var SBPS_3DS_TOKEN_URL = {
    "dev" : "https://stbtoken.sps-system.com/sbpstoken/com_sbps_system_tds2infotoken.js",
    "dev_mock" : "https://stbtoken.sps-system.com/sbpstoken/com_sbps_system_tds2infotoken.js",
    "browserstack" : "https://stbtoken.sps-system.com/sbpstoken/com_sbps_system_tds2infotoken.js",
    "it1" : "https://stbtoken.sps-system.com/sbpstoken/com_sbps_system_tds2infotoken.js",
    "it2" : "https://stbtoken.sps-system.com/sbpstoken/com_sbps_system_tds2infotoken.js",
    "st" : "https://stbtoken.sps-system.com/sbpstoken/com_sbps_system_tds2infotoken.js",
    "jedi_ols_st" : "https://stbtoken.sps-system.com/sbpstoken/com_sbps_system_tds2infotoken.js",
    "pr" : "https://token.sps-system.com/sbpstoken/com_sbps_system_tds2infotoken.js",
    "default" : "https://stbtoken.sps-system.com/sbpstoken/com_sbps_system_tds2infotoken.js"
}

var KIWI_URL = {
    "dev" : "https://api.sys.sit.itg.api.softbank.jp",
    "dev_mock" : "https://api.sys.sit.itg.api.softbank.jp",
    "browserstack" : "https://api.sys.sit.itg.api.softbank.jp",
    "it1" : "https://api.sys.sit.itg.api.softbank.jp",
    "it2" : "https://api.sys.sit.itg.api.softbank.jp",
    "st" : "https://api.sys.sit.itg.api.softbank.jp",
    "jedi_ols_st" : "https://api.sys.sit.itg.api.softbank.jp",
    "pr" : "https://ols.sbps.api.sys.itg.api.softbank.jp",
    "default" : "https://api.sys.sit.itg.api.softbank.jp"
}

/**
 * TORモックフラグ。
 * 0:TOR通信をモック化しない
 * 1:TOR通信をモック化する
 * @const
 */
var TOR_MOCK_FLG = {
    "dev" : "1",
    "dev_mock" : "1",
    "browserstack" : "1",
    "it1" : "0",
    "it2" : "0",
    "st" : "0",
    "jedi_ols_st" : "0",
    "pr" : "0",
    "default" : "0"
}
/**
 * SBPS通信フラグ。
 * 0:SBPS通信をしない
 * 1:SBPS通信をする
 * @const
 */
var SBPS_COMMUNICATION_FLG = {
    "dev" : "0",
    "dev_mock" : "0",
    "browserstack" : "0",
    "it1" : "1",
    "it2" : "1",
    "st" : "1",
    "jedi_ols_st" : "1",
    "pr" : "1",
    "default" : "1"
}
// クレジット番号等を設定し、トークンPAN取得用ｊｓパス
var PCIDSS_PASS = {
    "dev" : "../js/pcidss-mock.js?v=",
    "dev_mock" : "../js/pcidss-mock.js?v=",
    "browserstack" : "../js/pcidss-mock.js?v=",
    "it1" : "../js/pcidss.js?v=",
    "it2" : "../js/pcidss.js?v=",
    "st" : "../js/pcidss.js?v=",
    "jedi_ols_st" : "../js/pcidss.js?v=",
    "pr" : "../js/pcidss.js?v=",
    "default" : "../js/pcidss.js?v="
}

// Coming Soonページリスト
var comingSoonPageList = {
    "dev" : "http://10.235.27.7:8802/ols/html/order/index2.html",
    "dev_mock" : "http://10.235.27.7:8802/ols/html/order/index2.html",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/html/order/index2.html",
    "it1" : "https://st.online-shop.mb.softbank.jp/ols/html/order/index2.html",
    "it2" : "https://st.online-shop.mb.softbank.jp/ols/html/order/index2.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/html/order/index2.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/html/order/index2.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/html/order/index2.html",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/html/order/index2.html"
}

// 認証logout
var logoutList = {
    "dev" : "../js/j_ua.js",
    "dev_mock" : "../js/j_ua.js",
    "browserstack" : "../js/j_ua.js",
    "it1" : "https://st.id.softbank.jp/sbid_auth/type1/2.0/logout.php",
    "it2" : "https://st.id.softbank.jp/sbid_auth/type1/2.0/logout.php",
    "st" : "https://st.id.softbank.jp/sbid_auth/type1/2.0/logout.php",
    "jedi_ols_st" : "https://st.id.softbank.jp/sbid_auth/type1/2.0/logout.php",
    "pr" : "https://id.my.softbank.jp/sbid_auth/type1/2.0/logout.php",
    "default" : "https://st.id.softbank.jp/sbid_auth/type1/2.0/logout.php"
}